import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { MdClose } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import DropDown from '../Ui/DropDown';
import Loader from "react-loader-spinner";
import { dateTimeFormat } from '../../utils';
import { downloadFile } from '../../utils';
import * as jobsActions from '../../Redux/Actions/jobs';
import { toastMessage } from '../../utils/toast';

const AdditionalPaymentReferenceModal = ({ t, id, showModal, handleClose, loading, handleOk, paymentReferenceInfo, permissonRoles }) => {

    const [buttonLoading, setButtonLoading] = useState(false);
    const [selectType, setSelectType] = useState('');
    const [reason, setReason] = useState('');
    const [errMrg, setErrMsg] = useState('');

    const userData = useSelector(({ User }) => User.data);

    const updateStatus = [
        { value: 'Approved', label: 'Approved'},
        { value: 'Rejected', label: 'Rejected'},
    ];

    const handleSubmit = () => {
        if(reason && selectType?.value) {
            const payload = {
                additionalPaymentId: id,
                status: selectType?.value,
                reason: reason
               }
               handleOk(payload);
        } else {
            setErrMsg('Please Enter all the details!');
        }
    }

    const handleDownloadDocument = (id) => {
        setButtonLoading(true);
        jobsActions.downloadPaymentReceipt(id).then(res => {
            res && downloadFile(res);
            toastMessage('success', 'File downloaded successfully!');
            setButtonLoading(false);
        }).catch((err) => {
            toastMessage('error', 'Unable to download file!');
            setButtonLoading(false);
        });
    }

    const contentWrap = (str, num) => str.substring(0, num) + '...';
    
    return (
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered" style={{minWidth: '800px'}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("additionalPayments.additionalPaymentReference")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            { paymentReferenceInfo?.status === 'Pending' && permissonRoles?.includes(userData.Role) ? 
                            <>
                                <div className="d-flex flex-column">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.changeStatus")}</label>
                                    <DropDown value={selectType} placeholder={t("jobsManagement.infoJob.additionalPayment.selectStatus")} options={updateStatus} onChange={e => {setSelectType(e)}} />
                                </div>
                                <div>
                                    <p className="text-primary mb-2" >{t("jobsManagement.infoJob.additionalPayment.reason")}</p>
                                    <textarea onChange={e => {setReason(e.target.value); setErrMsg('')}} className="w-100 p-2" rows="4" placeholder={t("jobsManagement.infoJob.additionalPayment.enterReason")} />
                                </div>
                                <div className='d-flex justify-content-between mb-3'>
                                    <div></div>
                                    <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading} onClick={() => handleSubmit()}>{t("jobsManagement.infoJob.createReference.ok")}
                                        {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                    </button>
                                </div>
                                {errMrg && <p className='text-center my-2' style={{ color: 'red'}}>{errMrg}</p>}
                            </>
                            : null}
                            <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                                <thead>
                                    <tr className="text-left">
                                        <th className="pl-7" style={{width: '50px'}}>{t("jobsManagement.infoJob.additionalPayment.sNo")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.file")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.status")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.receiptNumber")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.reason")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.approvedBy")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.approvedDate")}</th>
                                    </tr>
                                </thead>
                                <tbody> 
                                    <tr>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{1}</span>
                                        </td>
                                        <td className="pl-7 text-center">
                                            <button className='btn btn-primary' disabled={buttonLoading} onClick={() => handleDownloadDocument(paymentReferenceInfo?.attachmentId)}>{ buttonLoading ? <Loader type="Oval" color="#fff" height={20} width={20} /> : <FiDownload className="c-pointer" />}</button>
                                        </td>
                                        <td className="text-center" style={{whiteSpace: 'nowrap'}}>
                                            <span className={"p-2 badge badge-outline-" + (paymentReferenceInfo?.status === 'Pending' ? "warning" : paymentReferenceInfo?.status === 'Approved' ? "success" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                {paymentReferenceInfo?.status}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.receiptNumber ? paymentReferenceInfo?.receiptNumber : '-'}</span>
                                        </td>
                                        <td className="text-center" style={{wordWrap: "break-word", minWidth: "160px", maxWidth: "160px"}}>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.reason ? contentWrap(paymentReferenceInfo?.reason, 25) : '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.approvedBy ? paymentReferenceInfo?.approvedBy?.name : '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.approvedTime ? dateTimeFormat(paymentReferenceInfo?.approvedTime) : '-'}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
}

export default AdditionalPaymentReferenceModal;